module.exports = __webpack_public_path__ + "static/media/2.7414f5f9.png";